import get from 'lodash/get';
import AnswersPreview from 'models/location/answers_preview';
import DtoConverter from 'scripts/application/dto_converters/search/snippet_search_result_converter';
import HandleAnswerSearchResults from 'actions/answers/handle_answer_search_results';
import { getActiveConversationId } from 'actions/conversation/lib/conversation_helpers';
import qconsole from 'scripts/lib/qconsole';

export default class SnippetSearchResultGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.snippetSearchResult;
  }

  onFetchSuccess(dto, id) {
    const search = DtoConverter.fromDto({ ...dto, id });

    const currentLocation = this.context.stores.currentLocation.get();
    if (currentLocation.customerId || currentLocation instanceof AnswersPreview) {
      this.context.executeAction(HandleAnswerSearchResults, { search });
      return;
    }

    const snippetSearchResult = this.store.get();
    if (snippetSearchResult && snippetSearchResult.id === search.id) {
      this.store.set(search);
      this.context.stores.snippets.set(search.hits);
    }
  }

  onFetchError(error) {
    qconsole.log(`Failed to fetch snippet search result ${JSON.stringify(error)}`);

    const currentLocation = this.context.stores.currentLocation.get();
    const customerId = currentLocation && currentLocation.customerId;
    const conversationsStore = this.context.stores.conversations;
    const conversationId = conversationsStore && getActiveConversationId(conversationsStore);
    const compositionId = currentLocation && currentLocation.currentCompositionId;
    const location = currentLocation instanceof AnswersPreview ? 'Answers Preview' : 'Customer Page';
    const pendingAnswerPanel = this.context.stores.answerPanel.getPending();
    const searchText = get(pendingAnswerPanel, 'searchResult.query.text') || '';

    this.context.stores.answerPanel.resetPending();

    this.context.analytics.track('Answer Panel Search Failed', {
      customerId,
      conversationId,
      compositionId,
      location,
      searchText,
    });
  }
}
